import { Box, Spinner } from '@factorialco/deprecated-design-system'

function Loading() {
  return (
    <Box gap="s8" padding="s48" alignItems="center" data-testid="compensations-loading">
      <Spinner size="s32" />
    </Box>
  )
}

export { Loading }
